export default __webpack_public_path__ + "static/media/news24712.3af223c2.webp";